import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { IDropPanelConfig } from '@fox/blocks/contracts/drop-panel';
import { SECTION_DROP_PANEL_TYPE } from '../../../form-block-types';
import { RenderBlockComponent } from '../../render-block-component';

function SectionDropPanelBlock({ props }: IBlockProps<IDropPanelConfig>) {
	return props.columns.map((c, i) => {
		const layouts = props.columnContents.find(content => content.columnIndex === i)?.items ?? [];
		return layouts.map(layout => {
			return <RenderBlockComponent {...layout} key={layout.id} />;
		});
	});
}

export const SectionDropPanelBlockRunTime: IBlockDefinition<IDropPanelConfig> = {
	type: SECTION_DROP_PANEL_TYPE,
	Component: SectionDropPanelBlock
};
